module.exports = __webpack_public_path__ + "img/app-3.3ee57432.png";